import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { TagCompanyProps } from "./types";

export class TagCompany extends BaseModel<TagCompanyProps> {
	id: string;
	name: string | null;
	code: string | null;

	constructor(data: TagCompanyProps) {
		super(data);
		this.id = data.id ?? "";
		this.name = data.name ?? "";
		this.code = data.code ?? "";
	}

	toOption = (): OptionLike => {
		return { ...this, label: this.name, value: this.id };
	};
}
